module.exports = __webpack_public_path__ + "img/1.a0db4ff.png";